module.exports = __webpack_public_path__ + "static/media/sound_gold.d0951e5d.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/sound_gold.ogg
// module id = 51
// module chunks = 0